import React, { useEffect, useState } from "react";
import "./ColorCard.css";
import { Grid } from "@mui/material";
import { fonts, themes } from "../../themes/themes";

interface colorCardType {
  tile_key: string;
  tile_value: any;
  value_color?: string;
  key_color?: string;
  is_bold?: boolean;
  is_thirdTitle?: any;
  is_FourthTitle?: any;
}
const ColorCard: React.FC<colorCardType> = ({
  tile_key,
  tile_value,
  value_color = themes.primary,
  key_color = themes.primary,
  is_bold = true,
  is_thirdTitle,
  is_FourthTitle,
}) => {
  return (
    <Grid container className="tile-container">
      <Grid
        item
        xs={6}
        style={{
          fontSize: fonts.title,
          fontFamily: fonts.fontFamily,
          color: key_color,
          textTransform: "capitalize",
          fontWeight: is_bold ? "bolder" : "normal",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        {tile_key}
      </Grid>
      <Grid
        item
        xs={6}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
          textTransform: "capitalize",
          fontWeight: is_bold ? "bolder" : "normal",
        }}
      >
        {tile_value}
      </Grid>
      {is_thirdTitle && (
        <Grid
          item
          xs={12}
          style={{
            marginTop: "0.5em",
            fontSize: fonts.smallSize,
            fontFamily: fonts.fontFamily,
            color: value_color,
            textAlign: "left",
            textTransform: "capitalize",
            fontWeight: is_bold ? "bolder" : "normal",
          }}
        >
          {is_thirdTitle}
        </Grid>
      )}
      {is_FourthTitle && (
        <Grid
          item
          xs={12}
          style={{
            marginTop: "0.2em",
            fontSize: fonts.smallSize,
            fontFamily: fonts.fontFamily,
            color: value_color,
            textAlign: "left",
            textTransform: "capitalize",
            fontWeight: is_bold ? "bolder" : "normal",
          }}
        >
          {is_FourthTitle}
        </Grid>
      )}
    </Grid>
  );
};

export default ColorCard;
